export interface Tenant {
  id: string;
  slug: string; // 'nissan', 'ford', 'toyota', etc.
  name: string; // 'Nissan Motor Company'
  domain?: string; // 'nissan.wattos.com'
  branding: TenantBranding;
  sso_config?: SSOConfig;
  settings: TenantSettings;
  created_at: string;
  updated_at: string;
}

export interface TenantBranding {
  primaryColor: string;
  secondaryColor: string;
  accentColor: string;
  logo?: string;
  favicon?: string;
  companyName: string;
  theme: 'light' | 'dark' | 'auto';
}

export interface SSOConfig {
  provider: 'okta' | 'azure' | 'google' | 'auth0' | 'custom';
  domain?: string;
  clientId?: string;
  issuer?: string;
  enabled: boolean;
}

export interface TenantSettings {
  allowUserRegistration: boolean;
  defaultUserRole: string;
  maxUsers?: number;
  features: TenantFeatures;
  timezone: string;
  dateFormat: string;
}

export interface TenantFeatures {
  chat: boolean;
  manufacturing: boolean;
  qualityControl: boolean;
  analytics: boolean;
  fileAttachments: boolean;
  customBranding: boolean;
}

export interface TenantContextType {
  tenant: Tenant | null;
  loading: boolean;
  error: string | null;
  isMultiTenant: boolean;
  switchTenant: (slug: string) => Promise<void>;
  refreshTenant: () => Promise<void>;
}

// Default tenant configuration
export const DEFAULT_TENANT_BRANDING: TenantBranding = {
  primaryColor: '#3b82f6', // blue-500
  secondaryColor: '#64748b', // slate-500
  accentColor: '#10b981', // emerald-500
  companyName: 'WattOS',
  theme: 'light'
};

export const DEFAULT_TENANT_SETTINGS: TenantSettings = {
  allowUserRegistration: true,
  defaultUserRole: 'user',
  features: {
    chat: true,
    manufacturing: true,
    qualityControl: true,
    analytics: true,
    fileAttachments: true,
    customBranding: false
  },
  timezone: 'UTC',
  dateFormat: 'MM/dd/yyyy'
}; 